import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  TtIcon,
  TtDropdown,
  TtIconButton,
  TtMenu,
  TtMenuItem,
  TtButton,
} from '@23/react'
import { useSortable } from '@dnd-kit/sortable'

interface ToolbarProps {
  cardId: string
  onEditClick?: () => void
  onDeleteClick?: () => void
  isMediaCard?: boolean
}

const Toolbar = ({
  cardId,
  onEditClick,
  onDeleteClick,
  isMediaCard = false,
}: ToolbarProps): JSX.Element => {
  const { attributes, listeners } = useSortable({
    id: cardId,
  })

  return (
    <>
      <TtIcon
        slot="toolbar"
        library="one"
        name="drag"
        data-drag-handle="true"
        {...listeners}
        {...attributes}
      />
      <TtDropdown slot="toolbar" placement="bottom-start" hoist>
        {isMediaCard ? (
          <div slot="trigger" className="icon-enclosure">
            <TtIconButton
              slot="trigger"
              library="one"
              name="more"
              label="Toolbar Menu"
            />
          </div>
        ) : (
          <TtButton
            slot="trigger"
            size="x-small"
            variant="ghost"
            color="secondary"
            circle
          >
            <TtIcon library="one" name="more" />
          </TtButton>
        )}
        <TtMenu>
          {onEditClick && (
            <TtMenuItem value="edit" onTt-click={onEditClick}>
              <FormattedMessage defaultMessage="Edit" />
            </TtMenuItem>
          )}
          {onDeleteClick && (
            <TtMenuItem value="delete" onTt-click={onDeleteClick}>
              <FormattedMessage defaultMessage="Delete" />
            </TtMenuItem>
          )}
        </TtMenu>
      </TtDropdown>
    </>
  )
}

export default Toolbar
